import {SurveyAnalyticsEvent} from "./SurveyAnalyticsEvent";

export class SurveyDisplayEvent extends SurveyAnalyticsEvent {
  type = 'SURVEY_DISPLAY_EVENT';
  dayOffset: number;
  questionId: string;
  locale: string;
  inviteCode: string;
}
